import Icon from '../components/Icon.vue'

Icon.register({
  hospital: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 492V512H0V492C0 485.4 5.4 480 12 480H32V120C32 106.7 42.7 96 56 96H144V24C144 10.7 154.7 0 168 0H280C293.3 0 304 10.7 304 24V96H392C405.3 96 416 106.7 416 120V480H436C442.6 480 448 485.4 448 492zM308 192H268C261.4 192 256 197.4 256 204V244C256 250.6 261.4 256 268 256H308C314.6 256 320 250.6 320 244V204C320 197.4 314.6 192 308 192zM140 256H180C186.6 256 192 250.6 192 244V204C192 197.4 186.6 192 180 192H140C133.4 192 128 197.4 128 204V244C128 250.6 133.4 256 140 256zM244 384H204C197.4 384 192 389.4 192 396V480H256V396C256 389.4 250.6 384 244 384zM308 288H268C261.4 288 256 293.4 256 300V340C256 346.6 261.4 352 268 352H308C314.6 352 320 346.6 320 340V300C320 293.4 314.6 288 308 288zM192 300C192 293.4 186.6 288 180 288H140C133.4 288 128 293.4 128 300V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340V300zM182 96H208V122A6-6 0 0 1 214 128H234A6-6 0 0 1 240 122V96H266A6-6 0 0 1 272 90V70A6-6 0 0 1 266 64H240V38A6-6 0 0 1 234 32H214A6-6 0 0 1 208 38V64H182A6-6 0 0 1 176 70V90A6-6 0 0 1 182 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hospital.js
// module id = 5o4u
// module chunks = 144